<template>
  <tr>
    <td>
      {{ $dayjs(data.end_at).tz(player.settings && player.settings.timezone ? player.settings.timezone : undefined).format('ll - ddd') }}
    </td>
    <td>
      {{ data.title }}
    </td>
    <td style="width: 1%">
      <training-load-chip
        :key="'event_stat_'+data.id"
        :training-load="data.player_stats ? data.player_stats.TL : null"
        :training-grade="data.player_stats ? data.player_stats.TG : null"
        :event-start-at="data.start_at"
        :event-end-at="data.end_at"
        :event-title="data.title"
        :training-duration="data.player_stats ? data.player_stats.TTM : null"
        :session-enjoyment="data.player_stats ? data.player_stats.ENJY : null"
        :player-timezone="player.settings && player.settings.timezone"
      />
    </td>
    <td>
      <pain-label
        v-if="data.player_stats"
        :label="data.player_stats.highest_pain ? data.player_stats.highest_pain.label : undefined"
        :value="data.player_stats.highest_pain ? data.player_stats.highest_pain.value : undefined"
        :player-stats="data.player_stats"
        :gender="player.gender"
      />
      <div
        v-else
        class="grey--text caption"
      >
        N/A
      </div>
    </td>
    <td
      v-for="tableHeader in tableHeaders.slice(4)"
      :key="tableHeader.id"
    >
      <table-bar-value
        v-if="data.player_stats"
        :value="data.player_stats[tableHeader.value]"
        :max="maxValues[tableHeader.value]"
        :color="tableHeader.colorable ? getColorFromValue(data.player_stats[tableHeader.value], maxValues[tableHeader.value], tableHeader.reverse) : 'grey lighten-2'"
      >
        {{ data.player_stats[tableHeader.value] }}
      </table-bar-value>
      <div
        v-else
        class="grey--text caption"
      >
        N/A
      </div>
    </td>
  </tr>
</template>

<script>

import TrainingLoadChip from '@/components/helpers/TrainingLoadChip.vue'
import TableBarValue from '@/components/helpers/TableBarValue.vue'
import { maxValuesPerformanceMatch } from '@/data/models/TableHeader'
import { getColorForValue } from '@/utils/helpers'
import PainLabel from '@/components/helpers/PainLabel.vue'

export default {
  name: 'PlayerMatchTableRow',
  components: { PainLabel, TableBarValue, TrainingLoadChip },
  props: {
    data: {
      type: Object,
      required: true
    },
    tableHeaders: {
      type: Array,
      required: true
    },
    player: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    maxValues: maxValuesPerformanceMatch
  }),
  methods: {
    getColorFromValue(value, max, reverse = false) {
      return getColorForValue(value, max, reverse)
    }
  }
}

</script>

<style scoped>

</style>
